export const availabilityReadable = (weekdays = []) => {
  if (!weekdays || !weekdays.length) return "(No Availability)";
  weekdays = weekdays.filter((n) => n); // Handle incorrect formatting
  if (weekdays.length === 7) return "Everyday";
  let availableWeekdays = isAvailableWeekdays(weekdays);
  if (weekdays.length === 6 && availableWeekdays) {
    if (weekdays.includes("Saturday")) return "Weekdays & Saturday";
    if (weekdays.includes("Sunday")) return "Weekdays & Sunday";
  }
  if (weekdays.length === 5 && availableWeekdays) return "Weekdays";
  if (
    weekdays.length === 2 &&
    weekdays.includes("Saturday") &&
    weekdays.includes("Sunday")
  )
    return "Weekends";
  if (weekdays.length === 1) return "Only On " + weekdays[0];
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  weekdays.sort((a, b) => {
    return days.indexOf(a) - days.indexOf(b);
  });
  return weekdays.join(", ");
};

const isAvailableWeekdays = (weekdays = []) => {
  return (
    weekdays.includes("Monday") &&
    weekdays.includes("Tuesday") &&
    weekdays.includes("Wednesday") &&
    weekdays.includes("Thursday") &&
    weekdays.includes("Friday")
  );
};

export const getItemCompletionMessage = (completion, primary = "", type = "") => {
  if (!completion) return "";
  switch (completion) {
  case "Graduated":
    if (type === "High School/GED") return "Graduated";
    if (type === "Other") return "Completed";
    if (!primary) return "Graduated with";
    return "Graduated in";
  case "Currently Attending":
    if (type === "High School/GED") return "Attending";
    if (!primary) return "Working Towards";
    return "Currently Studying";
  case "Partially Completed":
    if (!primary) return "Partially Completed";
    return "Studied at";
  case "Currently Working Here":
    return "(Current)";
  case "No Longer Working Here":
    return "";
  default:
    return "";
  }
};

export const getRankMessage = (rank) => {
  if (!rank) return "";
  switch (rank) {
  case 10:
    return "Renowned expert, made significant contributions";
  case 9:
  case 8:
    return "Expert, capable of teaching";
  case 7:
  case 6:
    return "Proficient with extensive experience";
  case 5:
  case 4:
    return "Good understanding and practical application";
  case 3:
  case 2:
    return "Familiar with skill concepts";
  case 1:
    return "Basic understanding of skill";
  default:
    return "";
  }
};

export const getCurrentEducation = (education = []) => {
  if (!education || !education.length) return null;
  for (let i = 0; i < education.length; i++) {
    if (education[i]?.completion === "Currently Attending") {
      return education[i];
    }
  }
  return null;
};

export const getMostRecentJob = (jobs = []) => {
  if (!jobs || !jobs.length) return null;
  for (let i = 0; i < jobs.length; i++) {
    if (jobs[i]?.completion === "Currently Working Here") {
      return jobs[i];
    }
  }

  return jobs.reduce((prev, current) => {
    if (!prev.end || !prev.start) return current; // Handle null values
    if (!current.end || !current.start) return prev; // Handle null values

    if (prev.end.year > current.end.year) {
      return prev;
    }

    if (prev.end.year < current.end.year) {
      return current;
    }

    if (prev.end.month > current.end.month) {
      return prev;
    }

    return current;
  });
};

export const getCareerShortSummary = (jobs = []) => {
  // 1. All jobs must have a start date (if not, filter them out)
  if (jobs && jobs.length) jobs = jobs.filter(job => job.start);

  // 2. If no jobs are provided, return "Not Provided"
  if (!jobs || !jobs.length) return "Not Provided";

  let totalMonthsWorking = 0;
  let totalJobs = 0;

  jobs.forEach(job => {
    const startDate = new Date(job.start);
    const endDate = job.end ? new Date(job.end) : new Date(); // If end date is not provided, consider current date.
    const monthsWorking = Math.abs(endDate.getMonth() - startDate.getMonth() +
      (12 * (endDate.getFullYear() - startDate.getFullYear())));
    totalMonthsWorking += monthsWorking;
    totalJobs += 1;
  });

  // totalMonthsWorking and averageMonthsTenure to be displayed in years if they are greater than 12
  let totalWorkingTime = totalMonthsWorking > 12 ? `${(totalMonthsWorking / 12).toFixed(1)} Years` : `${Math.round(totalMonthsWorking)} Months`;
  let averageTenure = totalMonthsWorking / totalJobs;
  averageTenure = averageTenure > 12 ? `${(averageTenure / 12).toFixed(1)} Years` : `${Math.round(averageTenure)} Months`;

  return `${totalJobs} Job${totalJobs > 1 ? "s" : ""} • ${totalWorkingTime} Working • ${averageTenure} Avg. Tenure`;
};

export const getEducationShortSummary = (education = []) => {
  if(!education || !education.length) return "Not Provided";

  const educationLevels = [
    "Not Provided",
    "High School/GED",
    "Associate's Degree",
    "Other",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctorate's Degree"
  ];

  let highestEducationIndex = 0;

  education.forEach(edu => {
    const eduIndex = educationLevels.indexOf(edu.type);
    if (eduIndex > highestEducationIndex) {
      highestEducationIndex = eduIndex;
    }
  });

  return educationLevels[highestEducationIndex];
};

export const arrayReadable = (array = []) => {
  if (!array || !array.length) return "Not Specified";
  if (typeof array === "string") array = array.split(",");
  if (array.length === 1) return array[0];
  return array.slice(0, -1).join(", ") + " & " + array.slice(-1);
};

export const educationComplete = (firstEducation) => {
  return !!(
    firstEducation &&
    firstEducation.type &&
    firstEducation.title
  );
};

export const careerPassportComplete = (firstCareerPassport) => {
  return !!(
    firstCareerPassport &&
    firstCareerPassport.primary &&
    firstCareerPassport.title
  );
};

export const exceptionalAbilityComplete = (exceptionalAbility) => {
  if (!exceptionalAbility) return false;
  return exceptionalAbility?.filter(Boolean).length >= 3;
};
